var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.598 19.241c-.657 1.657-1.695 3.298-3.085 4.877a1.48 1.48 0 0 0-.14 1.785 1.457 1.457 0 0 0 1.653.622c2.946-.861 9.819-3.919 10.003-13.692.071-3.774-2.689-7.016-6.283-7.382a7.063 7.063 0 0 0-5.432 1.773A7.03 7.03 0 0 0 1 12.431c0 3.303 2.345 6.192 5.598 6.81zM4.655 8.708a4.96 4.96 0 0 1 3.357-1.294c.176 0 .354.01.532.028 2.567.26 4.537 2.612 4.485 5.353-.127 6.762-3.789 9.807-6.821 11.169.96-1.298 1.713-2.633 2.25-3.986a1.914 1.914 0 0 0-.095-1.616 2.029 2.029 0 0 0-1.378-1.02A5.036 5.036 0 0 1 3 12.43c0-1.415.603-2.772 1.655-3.723zM19.344 25.903a1.457 1.457 0 0 0 1.652.622c2.946-.861 9.818-3.919 10.003-13.692.07-3.775-2.69-7.016-6.284-7.382a7.043 7.043 0 0 0-5.431 1.773 7.03 7.03 0 0 0-2.314 5.207c0 3.303 2.344 6.192 5.597 6.81-.657 1.659-1.695 3.3-3.085 4.877a1.478 1.478 0 0 0-.138 1.785zm5.083-5.924a1.915 1.915 0 0 0-.094-1.616 2.03 2.03 0 0 0-1.378-1.022 5.036 5.036 0 0 1-3.985-4.91c0-1.416.603-2.772 1.655-3.723a4.959 4.959 0 0 1 3.356-1.294c.176 0 .354.01.532.028 2.567.26 4.538 2.612 4.486 5.353-.127 6.763-3.79 9.807-6.821 11.169.959-1.297 1.711-2.632 2.249-3.985z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.391f44606bd0c708773bfe300ed0c020.svg";
export { ForwardRef as ReactComponent };